import { defineFilterConfig, filterFieldAdapters } from "@src/components/business-form";
import type { ActOfCheckingAvailabilityFilter } from "../../../../../../api/actOfCheckingAvailability";

/** Значения формы фильтра списка АПН для частичной инвентаризации склада. */
export interface StockPartialInventoryFilterFormValues {
    /** Код склада АПН. */
    divisionCode: number | null;
    /** Номер АПН. */
    num: string;
    /** Коды статусов АПН. */
    stateCodes: number[];
}

/** Конфигурация фильтра списка АПН для частичной инвентаризации склада. */
export const stockPartialInventoryFilterFormConfig = defineFilterConfig<
    StockPartialInventoryFilterFormValues,
    ActOfCheckingAvailabilityFilter
>({
    fields: {
        divisionCode: {
            type: "number",
            nullable: true,
            label: "Склад АПН",
            validation: { required: true },
            map: {
                from: (domain) => domain.DivisionCode ?? null,
                to: (value) => (value == null ? {} : { DivisionCode: value }),
            },
        },
        num: {
            type: "string",
            label: "Номер АПН",
            map: {
                from: (domain) => domain.NumMask ?? "",
                to: (value) => {
                    const trimmed = value.trim();
                    return { NumMask: trimmed === "" ? undefined : trimmed };
                },
            },
        },
        stateCodes: {
            type: "array",
            label: "Статусы АПН",
            map: filterFieldAdapters.entityCodes("StateCodes"),
        },
    },
});
